<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="trip-acoordion">
    <div class="col-md-4 mt-12" *ngIf="deleteAction">
      Selected: {{ SelectedNumber }}
    </div>
    <div class="dash-trucks-top2">
      <button
        type="button"
        class="button buttonBlue fixed-btn"
        (click)="GoToDocument('Add', null)"
        *ngIf="addBtn"
      >
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Add
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="selectDoc"
        (click)="onSelect()"
      >
        <img
          class="trucks-head-img"
          src="../../../assets/img/check-circle.svg"
        />
        Select
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="cancelDoc"
        (click)="onSelectCancel()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="deleteDoc"
        (click)="onDelete()"
      >
        <img class="trucks-head-img" src="../../../assets/img/delete.svg" />
        Delete
      </button>
      <button
        uppercase
        type="button"
        *ngIf="searchButton"
        class="button search-btn fixed-btn"
        (click)="openSearch()"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input
          class="search pl-2"
          placeholder="Document Name"
          id="documentName"
          style="text-transform: capitalize"
          #newItem
          (keyup)="onInputChange(newItem.value)"
          (keyup.enter)="isInputValid && search(newItem.value)"
        />
        <button
          [disabled]="!isInputValid"
          class="search_number"
          *ngIf="search_btn"
          (click)="search(newItem.value)"
        >
          <img src="../../../assets/img/search-white.svg" />
        </button>
        <button
          *ngIf="clear_Btn"
          class="search_number1"
          (click)="resetSearch()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            class="search_icon"
          >
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="trucks">
      <div [class.spinner]="loading"></div>

      <div class="row to_container" *ngIf="!DocumentList?.length && !loading">
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <div class="row">
        <div class="col-md-3" *ngFor="let item of DocumentList; let i = index">
          <div class="truckscol">
            <mat-checkbox
              *ngIf="checkBox"
              (change)="matItem($event, item._id, i)"
            ></mat-checkbox>
            <p>
              Doc Name: {{ item.document_name }}
              <img
                src="../../../assets/img/edit icon.png"
                class="editimg"
                (click)="GoToDocument('Edit', item)"
              />
            </p>
            <p class="truck-number">Model Name: {{ item.module }}</p>
            <p class="truck-date">
              Document Status: {{ item.document_status }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
